export default __webpack_public_path__ + "assets/default-avatar-3178dc65bea69e6bd324f2a7b585581b.png";